// Hooks
import apiGetDeps from "@/hooks/requests/apiGetDeps/apiGetDeps";
import { useBuyDeviceStore } from "@/stores/buyDevice/buyDevice";
// Store
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useTIWStore } from "@/stores/tiw/tiw";

/** Загрузить Бренды */
export default async function useBrands(): Promise<void> {
    const ChooseDeviceStore = useChooseDeviceStore();
    const BuyDeviceStore = useBuyDeviceStore();
    const TIWStore = useTIWStore();

    const brandsData = await apiGetDeps(TIWStore.WIDGET_DATA.token);

    // ChooseDeviceStore

    ChooseDeviceStore.brands = brandsData.data.brands
        .filter((el) => {
            return !["other brands"].includes(el.name.toLocaleLowerCase());
        })
        .map((el) => ({
            ...el,
            name: el.name.charAt(0).toUpperCase() + el.name.slice(1).toLowerCase(),
        }))
        .sort((a, b) => {
            const priority = ["Apple", "Samsung"];
            const aPriority = priority.indexOf(a.name);
            const bPriority = priority.indexOf(b.name);

            // Apple і Samsung завжди першими, в цьому порядку
            if (aPriority !== -1 || bPriority !== -1) {
                if (aPriority === -1) return 1;
                if (bPriority === -1) return -1;

                return aPriority - bPriority;
            }

            return a.name.localeCompare(b.name);
        });

    ChooseDeviceStore.categories = brandsData.data.categories;
    ChooseDeviceStore.brandsCategories = brandsData.data.brands_categories;

    // BuyDeviceStore

    BuyDeviceStore.field_brand.data = brandsData.data.brands;

    BuyDeviceStore.manualCharacteristicsData.brand = brandsData.data.brands;
    BuyDeviceStore.manualCharacteristicsData.brand_categories = brandsData.data.brands_categories;
    BuyDeviceStore.manualCharacteristicsData.category = brandsData.data.categories;
}
